<script>
  import auth from "../../firebase";
  import firebase from "firebase/app";
  import { users } from "../../stores";
  import { fade, fly } from "svelte/transition";

  let disabled = "";
  let phonenumber;
  let otp;
  let isotpsent = false;
  let otpsentalert = false;
  let incorrectotp = false;
  let invalnumber = false;

  function updateStores() {
    users.set({ ...$users, loggedIn: true });
  }
  setTimeout(function () {
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "recaptcha-container",
      {
        size: "invisible",
        callback: function (response) {
          console.log("success", response);
        },
        "expired-callback": function () {
          console.log("expired-callback");
        },
      }
    );

    recaptchaVerifier.render().then(function (widgetId) {
      window.recaptchaWidgetId = widgetId;
    });
  }, 10);
  function getOtp() {
    const appVerifier = window.recaptchaVerifier;
    let toSendphonenumber = "+91" + phonenumber;

    auth
      .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(function () {
        auth
          .signInWithPhoneNumber(toSendphonenumber, appVerifier)
          .then((confirmationResult) => {
            // SMS sent. Prompt user to type the code from the message, then sign the
            // user in with confirmationResult.confirm(code).
            isotpsent = true;
            disabled = "disabled";
            otpsentalert = true;
            invalnumber = false;
            window.confirmationResult = confirmationResult;

            // ...
          })
          .catch((error) => {
            console.log(error);
            // Error; SMS not sent
            // ...
            invalnumber = true;
            otpsentalert = false;
            isotpsent = false;
          });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  function editNumber() {
    disabled = "";
    isotpsent = false;
    otp = null;
    otpsentalert = false;
    incorrectotp = false;
    invalnumber = false;
  }

  function verify() {
    confirmationResult
      .confirm(otp)
      .then((result) => {
        // User signed in successfully.
        updateStores();
      })
      .catch((error) => {
        // User couldn't sign in (bad verification code?)
        // ...
        incorrectotp = true;
        otpsentalert = false;
        invalnumber = false;
      });
  }
</script>

<div id="recaptcha-container" />

<div class="page page-center">
  <div class="container-tight py-4">
    <div class="card card-md">
      <div class="card-body text-center py-4 p-sm-5">
        <img
          src="https://preview.tabler.io/static/logo.svg"
          height="48"
          alt=""
        />
      </div>
      <div class="hr-text hr-text-center hr-text-spaceless">
        Login With Number
      </div>
      <div class="card-body">
        {#if otpsentalert == true}
          <div
            class="alert alert-success alert-dismissible"
            role="alert"
            in:fly={{ x: 250, duration: 500 }}
            out:fade
          >
            <div class="d-flex">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-circle-check alert-icon"
                  width="44"
                  height="44"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <circle cx="12" cy="12" r="9" />
                  <path d="M9 12l2 2l4 -4" />
                </svg>
              </div>
              <div>
                <h4 class="alert-title">Success! OTP Sent!</h4>
                <div class="text-muted">
                  OTP sent to {phonenumber}.<br />
                </div>
              </div>
            </div>
          </div>
        {/if}
        {#if incorrectotp == true}
          <div
            class="alert alert-danger alert-dismissible"
            role="alert"
            in:fly={{ x: 250, duration: 500 }}
            out:fade
          >
            <div class="d-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-alert-circle alert-icon"
                width="44"
                height="44"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <circle cx="12" cy="12" r="9" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              <div />
              <div>
                <h4 class="alert-title">Invalid OTP!</h4>
                <div class="text-muted">
                  OTP is incorrect. Enter a valid OTP.
                </div>
              </div>
            </div>
          </div>
        {/if}
        {#if invalnumber == true}
          <div
            class="alert alert-warning alert-dismissible"
            role="alert"
            in:fly={{ x: 250, duration: 500 }}
            out:fade
          >
            <div class="d-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-alert-triangle alert-icon"
                width="44"
                height="44"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M12 9v2m0 4v.01" />
                <path
                  d="M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
                />
              </svg>
              <div />
              <div>
                <h4 class="alert-title">Invalid Phone Number!</h4>
                <div class="text-muted">Enter a valid Phone Number.</div>
              </div>
            </div>
          </div>
        {/if}
        <div class="mb-3">
          <span class="form-label">Phone Number</span>
          <div class="input-group">
            <span class="input-group-text"> +91 </span>

            <input
              type="text"
              name="input-mask"
              class="form-control"
              bind:value={phonenumber}
              {disabled}
              data-mask="00000-00000"
              data-mask-visible="true"
              autocomplete="off"
              required
              maxlength="10"
            />
          </div>
          <div class="form-hint">Enter 10 Digit Phone Number</div>
        </div>
        {#if isotpsent == true}
          <div class="mb-3">
            <span class="form-label">Enter OTP</span>
            <div class="input-group">
              <input type="text" class="form-control" bind:value={otp} />
            </div>
          </div>
        {/if}
      </div>
    </div>
    <div class="row align-items-center mt-3">
      <div class="col-4">
        <div class="btn-list justify-content-start">
          {#if isotpsent == true}
            <button class="btn btn-outline-warning" on:click={editNumber}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-pencil"
                width="44"
                height="44"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4" />
                <line x1="13.5" y1="6.5" x2="17.5" y2="10.5" />
              </svg>
              Edit Number
            </button>
          {/if}
        </div>
      </div>
      <div class="col-8">
        <div class="btn-list justify-content-end">
          {#if isotpsent == true}
            <button href="#" class="btn btn-success" on:click={verify}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-fingerprint"
                width="44"
                height="44"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3" />
                <path d="M8 11a4 4 0 0 1 8 0v1a10 10 0 0 0 2 6" />
                <path d="M12 11v2a14 14 0 0 0 2.5 8" />
                <path d="M8 15a18 18 0 0 0 1.8 6" />
                <path d="M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 12 -6.95" />
              </svg>
              Verify
            </button>
          {/if}
        </div>
        <div class="btn-list justify-content-end">
          {#if isotpsent == false}
            <button href="#" class="btn btn-success" on:click={getOtp}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-key"
                width="44"
                height="44"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <circle cx="8" cy="15" r="4" />
                <line x1="10.85" y1="12.15" x2="19" y2="4" />
                <line x1="18" y1="5" x2="20" y2="7" />
                <line x1="15" y1="8" x2="17" y2="10" />
              </svg>Get OTP
            </button>
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>
